import { Platform } from 'react-native';
export default {
  toggleIcon: {
    image: "",
    width: 10,
    height: 10
  },
  containerStyles: {
    width: "100%"
    //padding: 15,
  },
  listItemStyles: {
    paddingTop: 10,
    paddingBottom: 10
  },
  subListItemStyles: {
    padding: 10
  },
  textItemContainerStyles: {
    flexDirection: "row"
  },
  textItemStyles: {
    paddingLeft: Platform.OS == "web" ? "1rem" : 5,
    paddingRight: Platform.OS == "web" ? "1rem" : 5
  },
  selectedTextItemStyles: {
    borderBottomWidth: 4,
    borderBottomColor: "#F1C400"
  },
  inlineDisplay: {
    display: Platform.OS == "web" ? "inline-block" : "none"
  }
};